import { StripePrice } from '../types';
import apiRequest from './apiRequest';

type HostedCheckoutData = {
  url: string;
};

export default async function beginHostedCheckout(
  price: StripePrice,
  quantity: number = 1,
) {
  const isSubscription = price.recurring !== null;
  const mode = isSubscription ? 'subscription' : 'payment';

  return apiRequest<HostedCheckoutData>(
    'user',
    `/users/beginHostedCheckout?priceID=${price.id}&quantity=${quantity}&mode=${mode}`,
  );
}
